import StatusBadge from "../../generals/StatusBadge";

function formatValue(value) {
  if (value === null || value === undefined || value === "") return "-";
  return String(value);
}

function DetailRow({ label, value }) {
  return (
    <div className="mt-2 flex flex-row items-start text-gray-700">
      <div className="w-[140px] flex-shrink-0 text-sm mr-2">{label}</div>
      <div className="text-xs font-bold break-words">{formatValue(value)}</div>
    </div>
  );
}

function JobLocationOverview({ jobLocation }) {
  if (!jobLocation) return null;

  return (
    <div className="border-[1px] border-gray-200 rounded-lg p-4 @container">
      <div className="w-full @xl:grid @xl:grid-cols-5 @xl:gap-4">
        <div className="mt-3 @xl:col-span-3">
          <div className="text-gray-600 font-bold text-xl">
            {jobLocation.name}
          </div>
          <DetailRow label="Job Location ID" value={jobLocation.id} />
          <DetailRow label="Name" value={jobLocation.name} />
          <div className="mt-2 flex flex-row items-center text-gray-700">
            <div className="w-[140px] flex-shrink-0 text-sm mr-2">Status</div>
            <StatusBadge
              statusId={jobLocation.statusId}
              statusName={jobLocation.statusName}
            />
          </div>
          <DetailRow label="Created By" value={jobLocation.createdBy} />
          <DetailRow label="Created At" value={jobLocation.createdAt} />
          <DetailRow label="Last Changed By" value={jobLocation.lastChangedBy} />
          <DetailRow label="Last Changed At" value={jobLocation.lastChangedAt} />
        </div>
      </div>
    </div>
  );
}

export default JobLocationOverview;
